import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { AppConfigService } from "../app-config/app-config.service";

@Injectable()
export class LanguageCurrencyGuard implements CanActivate {

  constructor(
    private appConfigService: AppConfigService,
    private router: Router
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const currentURL = this.router.parseUrl(state.url);
    const langParams = currentURL.queryParams['lang'];
    const langCookie = this.appConfigService.getLanguageFromCookie();

    if (langParams) {
      if (langCookie) {
        if (langParams !== langCookie) {
          currentURL.queryParams['lang'] = langCookie;
          this.router.navigateByUrl(currentURL, { replaceUrl: true });
          return false;
        }
      } else {
        if (!this.appConfigService.isValidLanguage(langParams)) {
          currentURL.queryParams['lang'] = this.appConfigService.getLanguage();
          this.router.navigateByUrl(currentURL, { replaceUrl: true });
          return false;
        }
      }
    } else {
      currentURL.queryParams['lang'] = this.appConfigService.getLanguage();
      this.router.navigateByUrl(currentURL, { replaceUrl: true });
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/guard/language-currency.guard.ts